import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { getListExecutionContainerAppQuery } from '../apis';
import { setFieldContainerApp } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';

const useGetListExecutionContainerApp = ({
  appInstanceId,
  containerAppId,
  startDate,
  endDate,
}) => {
  const dispatch = useDispatch();

  const getData = useQuery({
    queryKey: [
      'container-app-job-execution-list' +
        JSON.stringify({
          appInstanceId,
          containerAppId,
          startDate,
          endDate,
        }),
    ],
    queryFn: () =>
      getListExecutionContainerAppQuery({
        appInstanceId,
        containerAppId,
        startDate,
        endDate,
      }),
  });

  useEffect(() => {
    const data = typeof getData !== 'undefined' ? getData?.data?.data : [];

    if (data) {
      dispatch(
        setFieldContainerApp({
          field: 'jobExecutions',
          value: deepClone(data),
        }),
      );
    }
  }, [getData?.data, dispatch]);

  return getData;
};

export default useGetListExecutionContainerApp;
